import { filter_day, filter_month, filter_week } from '../../../../../views/marketing/overview/PeriodFilter';

export default {
  filters: {
    [filter_day]: 'Päivä',
    [filter_week]: 'Viikko',
    [filter_month]: 'Kuukausi',
    null: 'Yhteensä',
  },
};
